import { MutationTuple, useMutation } from '@apollo/client';
import { RejectFitupInput, RejectFitupPayload } from '@bechtel/types';
import { REJECT_FITUP } from '@bechtel/client-gql';

export function useRejectFitup(
  onActionCompleted?: () => void,
  refetchQueries?: string[]
): MutationTuple<{ rejectFitupPayload: RejectFitupPayload }, { input: RejectFitupInput }> {
  const response = useMutation<{ rejectFitupPayload: RejectFitupPayload }, { input: RejectFitupInput }>(REJECT_FITUP, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      if (onActionCompleted) onActionCompleted();
    },
    onError: () => {
      if (onActionCompleted) onActionCompleted();
    },
    refetchQueries,
  });
  return response;
}
